export default __webpack_public_path__ + "static/media/16.cc47e0ad.JPG";